// One place for the site's identity as search engines and link previews see it.
export const SITE_URL = 'https://erp.rayasolutions.in';
export const SITE_NAME = 'Raya ERP';
export const TITLE_SUFFIX = ` | ${SITE_NAME}`;
export const LOCALE = 'en_IN';
export const LANG = 'en-IN';
export const DEFAULT_OG_IMAGE = { url: '/og-image.png', width: 1200, height: 630, alt: 'Raya ERP — run your whole business on one AI-powered platform' };

export const absoluteUrl = (path = '/') => (/^https?:/.test(path) ? path : `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`);
